import {
  ProductBundleCreate,
  ProductBundleEdit,
  ProductBundleList,
  ProductBundleShow
} from 'pages/ecommerce/product_bundles';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'products/bundles',
  label: 'Combos',
  list: ProductBundleList,
  create: ProductBundleCreate,
  edit: ProductBundleEdit,
  show: ProductBundleShow,
  actions: ['list', 'create', 'show', 'edit'],
  parentName: 'ecommerce'
};

export default generateResources(resource);
